var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 h-100",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('div', {
    staticClass: "big-white"
  }, [_c('div', {
    attrs: {
      "id": "itemList"
    }
  }, [_vm._l(_vm.itemsForList, function (project) {
    var _vm$profile, _vm$profile2;
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.shouldShowProject(project),
        expression: "shouldShowProject(project)"
      }],
      key: project.id,
      class: {
        'list-item': true,
        'disabled': !project.enabled,
        'my-list-item': project.id === ((_vm$profile = _vm.profile) === null || _vm$profile === void 0 ? void 0 : _vm$profile.projectId)
      }
    }, [_c('div', {
      staticClass: "projectName"
    }, [(project === null || project === void 0 ? void 0 : project.id) === ((_vm$profile2 = _vm.profile) === null || _vm$profile2 === void 0 ? void 0 : _vm$profile2.projectId) ? _c('img', {
      staticClass: "flag",
      attrs: {
        "src": require("@/assets/customer-project/flag.svg")
      }
    }) : _c('img', {
      staticClass: "flag",
      attrs: {
        "src": require("@/assets/customer-project/flag_empty.svg")
      }
    }), _vm._v(" " + _vm._s(project.name) + " ")]), _c('div', {
      staticClass: "openLink",
      on: {
        "click": function ($event) {
          return _vm.showDetails(project.id);
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.$t('open')) + " "), _c('img', {
      staticClass: "arrow",
      attrs: {
        "src": require("@/assets/customer-project/rightArrow.svg")
      }
    })])]);
  }), _c('b-pagination', {
    staticClass: "pagination",
    attrs: {
      "total-rows": _vm.projects.length,
      "per-page": _vm.perPage,
      "aria-controls": "itemList",
      "align": "right",
      "limit": "5",
      "hide-goto-end-buttons": ""
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  }, [_c('template', {
    slot: "prev-text"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/customer-project/prev.svg")
    }
  }), _vm._v(" " + _vm._s(_vm.$t('prev')) + " ")]), _c('template', {
    slot: "next-text"
  }, [_vm._v(" " + _vm._s(_vm.$t('next')) + " "), _c('img', {
    staticClass: "icon",
    attrs: {
      "src": require("@/assets/customer-project/next.svg")
    }
  })])], 2)], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }